<template>
  <div>
    <IsiTeks halaman="tentang-penulis" />
  </div>
</template>

<script>
import IsiTeks from '../components/IsiTeks'

export default {
  components: {
    IsiTeks
  }  
}
</script>